import React, { useContext, useState, useEffect } from 'react';
import { LoadingContext } from '../../contexts/LoadingContext';
import { getMe, updateMe, StandardUserOutDTO, StandardUserUpdateInDTO } from '../../services/api';
import { handleError, getFieldError } from '../../utils/errorUtils';
import { validateOptionalPhone } from '../../utils/phoneUtils';
import PhoneField from '../../components/inputs/PhoneField/PhoneField';
import { showSuccessToastFullScreen, showErrorToastFullScreen } from '../../utils/toastUtils';

import css from './Profile.module.scss';


const Profile: React.FC = () => {
  const { setIsLoading } = useContext(LoadingContext);
  const [userData, setUserData] = useState<StandardUserOutDTO | null>(null);
  const [phone, setPhone] = useState<string>();
  const [phoneError, setPhoneError] = useState<string>();

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        setIsLoading(true);
        const getMeResponse = await getMe();
        setUserData(getMeResponse);
        setPhone(getMeResponse.phone || undefined);
      } catch (error) {
        handleError(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserData();
  }, [setIsLoading]);

  const handleUpdateButtonClick = async () => {
    const phoneCheck = validateOptionalPhone(phone);
    if (!phoneCheck.ok) {
      setPhoneError(phoneCheck.error);
      return;
    }
    try {
      setIsLoading(true);
      const updateData: StandardUserUpdateInDTO = {
        firstName: (document.getElementById('firstName') as HTMLInputElement).value,
        lastName: (document.getElementById('lastName') as HTMLInputElement).value,
        phone: phoneCheck.value,
        linkedinUrl: (document.getElementById('linkedinAddress') as HTMLInputElement).value || undefined,
      };

      const updatedUser = await updateMe(updateData);
      setUserData(updatedUser);
      setPhone(updatedUser.phone || undefined);
      showSuccessToastFullScreen('Profile updated successfully');
    } catch (error) {
      const fieldError = getFieldError(error, 'phone');
      if (fieldError) {
        setPhoneError(fieldError);
      } else {
        handleError(error);
        showErrorToastFullScreen('Failed to update profile');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
      <div className={css.profile}>
        <div className={css.formGroup}>
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            defaultValue={userData?.username || ''}
            readOnly
            className={css.readOnlyField}
            tabIndex={-1}
            onFocus={(e) => e.target.blur()}
            style={{ userSelect: 'none' }}
          />
        </div>
        <div className={css.formGroup}>
          <label htmlFor="firstName">First Name *</label>
          <input type="text" id="firstName" name="firstName" defaultValue={userData?.firstName || ''} />
        </div>
        <div className={css.formGroup}>
          <label htmlFor="lastName">Last Name *</label>
          <input type="text" id="lastName" name="lastName" defaultValue={userData?.lastName || ''} />
        </div>
        <div className={css.formGroup}>
          <label htmlFor="phone">Phone</label>
          <PhoneField
            id="phone"
            className={css.phoneField}
            value={phone}
            onChange={(v) => { setPhone(v); setPhoneError(undefined); }}
            error={phoneError}
          />
        </div>
        <div className={css.formGroup}>
          <label htmlFor="linkedinAddress">LinkedIn Address</label>
          <input type="url" id="linkedinAddress" name="linkedinAddress" defaultValue={userData?.linkedinUrl || ''} />
        </div>
        <button className={css.search} onClick={handleUpdateButtonClick}>Update</button>
    </div>
  );
};

export default Profile;